/* eslint-disable react-hooks/exhaustive-deps */
import { Row } from 'antd'
import { Line } from 'src/components/helpers/line'
import styles from './OverviewChart.module.scss'
import React, { useEffect, useState } from 'react'
import { i18n, useTranslation } from 'next-i18next'
import { CustomCol, CustomTitle } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { prepareChart, prepareMonthChart } from 'src/core/helpers'
import {
  isProjectDeveloperUserState,
  summaryOrdersDataSelector,
  summarySalesDataSelector,
  currencyListSelector,
  getUserOrdersData,
  getUserSalesData
} from 'src/features'

const OverviewChart: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const currencyList = useAppSelector(currencyListSelector)
  const isProjectDeveloperUser = useAppSelector(isProjectDeveloperUserState)
  const { list: salesData, plotData: salesPlotData } = useAppSelector(
    summarySalesDataSelector
  )
  const { list: ordersData, plotData: ordersPlotData } = useAppSelector(
    summaryOrdersDataSelector
  )

  const [dataDetails, setDataDetails] = useState({
    salesTotalTCO2E: undefined,
    ordersTotalTCO2E: undefined
  })
  const [config, setConfig] = useState({
    data: [],
    xField: 'eje_x',
    yField: 'eje_y',
    seriesField: 'type',
    smooth: true
  })

  const filter = useAppSelector((state) => state.summary.filter)
  const chartHeigth = i18n?.language === 'de' ? '15.6rem' : '17.3rem'
  const getRate = (code: string) =>
    currencyList.find((token) => token.code === code)?.rate

  const prepareView = () => {
    const preparedChart = prepareChart({
      salesData,
      filter,
      t,
      getRate,
      ordersData,
      isProjectDeveloperUser,
      setConfig
    }).dataDetails
    if (filter < 31) {
      setDataDetails(preparedChart)
      return
    }
    const preparedMonthChart = prepareMonthChart({
      salesData,
      t,
      ordersData,
      isProjectDeveloperUser,
      setConfig,
      getRate
    })
    setDataDetails(preparedMonthChart.dataDetails)
  }

  useEffect(() => {
    dispatch(getUserSalesData(filter))
    dispatch(getUserOrdersData(filter))
  }, [filter])

  useEffect(() => {
    if (salesPlotData && ordersPlotData) {
      prepareView()
    }
  }, [filter, salesPlotData, ordersPlotData])

  return (
    <>
      {/* Texts */}
      <Row>
        <CustomCol xs={12}>
          <CustomTitle
            label={t('Summary.TCO2EMitigated')}
            className={styles.text1}
          />
          <CustomTitle
            label={`${dataDetails?.ordersTotalTCO2E?.toFixed(
              3
            )} tCO₂`}
            className={styles.text2}
            type={null}
          />
        </CustomCol>
        {isProjectDeveloperUser && (
          <CustomCol xs={12}>
            <CustomTitle
              label={t('Summary.TCO2ESold')}
              className={styles.text1}
            />
            <CustomTitle
              label={`${dataDetails?.salesTotalTCO2E?.toFixed(
                3
              )} tCO₂`}
              className={styles.text2}
              type={null}
            />
          </CustomCol>
        )}
      </Row>

      {/* Chart */}
      <Line
        {...config}
        style={{
          height: chartHeigth,
          position: 'relative',
          top: '-30px'
        }}
        loading={!(salesPlotData && ordersPlotData)}
      />
    </>
  )
}
export default OverviewChart
